<template>
  <div class="wabident-dropdown">
    <input type="text" :id="name" class="form-control wabident-dropdown__field" v-model="selectedValue" @change="">

    <div class="wabident-dropdown__btn" @click="show_dropdown = !show_dropdown">
      <i class="fas fa-chevron-down"></i>
    </div>

    <transition name="fade">
      <div v-if="show_dropdown" type="text" class="wabident-dropdown__dropdown">
        <div v-for="option in filtered_options" class="wabident-dropdown__item" @click="selectOption(option)">
          {{ option }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['value', 'options', 'name'],
  data() {
    return {
      selectedValue: this.value,
      show_dropdown: false,
    }
  },
  computed: {
    filtered_options() {
      return this.options;
    }
  },
  watch: {
    value(v) {
      this.selectedValue = v;
    }
  },
  methods: {
    changeVal() {
      this.$emit('input', this.selectedValue);
    },
    selectOption(option) {
      this.selectedValue = option;
      this.show_dropdown = false;
      this.$emit('input', option);
    }
  }
}
</script>

<style lang="scss">
.wabident-dropdown {
  position: relative;
  overflow-y: visible;
  width: 100%;

  &__field {
    width: 100%;
    padding-right: 50px !important;
  }

  &__dropdown {
    background: white;
    color: var(--theme-text-color);
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    width: 100%;
    height: auto;
    z-index: 20;
    border-radius: 0;
    background: var(--theme-grey-bg);
    border: 1px var(--theme-grey) solid;
  }

  &__btn {
    position: absolute;
    width: 40px;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    right: 0;
    top: 0;
    color: var(--theme-grey);
    z-index: 20;
  }

  &__item {
    transition: .3s;
    cursor: pointer;
    padding: 5px 10px;

    &.selected,
    &:hover {
      color: white;
      font-weight: bold;
      background-color: var(--theme-color);
    }
  }
}
</style>
